import { WORDS } from "../constants/wordlist";
import { WORDS_NO } from "../constants/wordlist-no";
import { getRandomSolution } from "../constants/solutions";
import { getRandomSolutionNo } from "../constants/solutions-no";
import type { GameLocale } from "../i18n/types";

export const isWordInWordList = (word: string, locale: GameLocale) => {
  const w = word.toLowerCase();
  if (locale === "no") {
    return WORDS_NO.includes(w);
  }
  return WORDS.includes(w);
};

export const isWinningWord = (word: string, solution: string) => {
  return solution === word;
};

export const getRandomSolutionWord = (locale: GameLocale): string => {
  if (locale === "no") {
    return getRandomSolutionNo().toUpperCase();
  }
  return getRandomSolution().toUpperCase();
};
